import React, { useState, createContext, useContext } from "react";

interface AppContextProps {
	loading: boolean;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
	headerState: HeaderStateProps;
	setHeaderState: React.Dispatch<React.SetStateAction<HeaderStateProps>>;
}
interface HeaderStateProps {
	hide: boolean;
	solid: boolean;
	disable: boolean;
}
export const AppContext = createContext({} as AppContextProps);

const AppProvider: React.FC = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [headerState, setHeaderState] = useState({
		hide: false,
		solid: false,
		disable: false
	});

	return <AppContext.Provider value={{ loading, setLoading, headerState, setHeaderState }}>{children}</AppContext.Provider>;
};

export const useLoading = () => {
	const { loading, setLoading } = useContext(AppContext);
	return { loading, setLoading };
};

export const useHeaderState = () => {
	const { headerState, setHeaderState } = useContext(AppContext);
	const initHeaderState = () =>
		setHeaderState({
			hide: false,
			solid: false,
			disable: false
		});
	return { headerState, setHeaderState, initHeaderState };
};

export default AppProvider;
